module.exports = __webpack_public_path__ + "static/media/podcast-nav-icon.1fa4415d.svg";